
import { useDispatch, useSelector } from "react-redux";
import Wrapper from "../../pages/styles/AllUsersContainerWrapper";
import Users from "./Users";
import Loading from "../Loading";

const AllUsersContainer = () => {
    const { isLoading, listOfUsers } = useSelector((store) => store.users);

    if (isLoading) {
        return <Loading center/>
    }
    if (listOfUsers.length == 0) {
        return (
            <Wrapper>
            <h2>No users found!</h2>
        </Wrapper>
        )
    }

    return (
       <Wrapper>
            <h5>Users</h5>
            <div className="users">
                {listOfUsers.map((user) => {
                    return <Users key={user._id} {...user}/>
                })}
            </div>
       </Wrapper>
    )
}

export default AllUsersContainer;